import React from "react"

import { createElement } from "../utils/create-elements"
import { createElementsWithBreadcrumb } from "../utils/create-elements-with-breadcrumb"

const Page = ({ blok, breadcrumb }) => {
  if (blok.hideBreadcrumb) {
    return <>{createElement(blok)}</>
  }
  return <>{createElementsWithBreadcrumb(blok, null, breadcrumb)}</>
}

export default Page
